module.exports = __webpack_public_path__ + "static/img/20-essex-street-crs.cbd40ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/20-essex-street-crs.png
// module id = nzRC
// module chunks = 0